import React, { useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { useDashboardStore } from '../stores/dashboardStore';
import './QA.css';

const QA: React.FC = () => {
    const { config } = useDashboardStore();
    const [activeCategory, setActiveCategory] = useState<string>('all');

    // 模拟问答数据
    const qaData = [
        {
            id: 1,
            category: 'education',
            question: '为什么选择产品经理这个职业？',
            answer: '我选择产品经理这个职业主要有以下几个原因：\n\n首先，我具备扎实的技术学习背景。我系统学习了编程、用户体验设计、系统分析等课程，对软件产品的架构、可行性以及可用性有深入理解，能与技术团队高效沟通。同时，我自学了AIGC、RAG等AI相关技术内容，对AI产品的底层逻辑和发展方向保持持续关注。\n\n其次，我擅长洞察用户需求。在项目经历中，我负责设计问卷、开展用户访谈、整理洞察与建模，习惯从用户行为与动机出发挖掘真实需求，而不是停留在表面痛点。我享受与用户沟通并把信息结构化的过程。\n\n再次，我具备数据分析与验证能力。熟悉数据分析流程、能够从数据中识别问题与机会点，并通过小规模实验验证产品假设，从而推动产品快速迭代与优化。\n\n最后，我想做“有价值的产品”。我希望打造能真正帮助用户、提升效率甚至改善生活和工作方式的产品，尤其是在AI应用不断发展的今天，我期待参与构建下一代智能产品，让技术为更多用户创造价值。',
            tags: ['职业选择', '产品思维', '技术背景']
        },
        {
            id: 2,
            category: 'experience',
            question: '在实习中最大的收获是什么？',
            answer: '✅ 一、产品实操能力：从“理解流程”到“能落地执行\n\n”过去只是书本上知道流程，而实习让我真正经历了产品从调研 → 方案设计 → 评审 → 联调 → 上线 → 复盘的完整周期，理解产品落地的细节与节奏。\n\n1. 设计并执行问卷与用户访谈，把用户需求落到真实场景\n\n2. 参与AB实验设计与分析，体会用数据说话与快速验证假设\n\n3. 参与功能设计、需求文档编写、与研发对齐方案\n\n4. 跟进开发、联调上线，并复盘上线效果和反馈\n\n这些经验让我从知道变成会做——更明确产品决策逻辑，且具备独立推动小模块上线的能力。\n\n✅ 二、团队协作与工作方式：更专业、更高效\n\n除了方法论，我得到的另一个核心成长是如何更高效地与同事协作和沟通。\n\n1. 养成工作留痕习惯：需求变更、设计依据、数据结论都文档化，减少沟通损耗\n\n2. 学会跨团队对齐：提前准备信息、明确owner与时间线、关键节点主动同步\n\n3. 意识到高质量问题意识：遇到问题不只“反馈问题”，而是带着背景、备选方案和评估来沟通\n\n4. 结构化表达与复盘文化：把想法、实验结论、路径记录清晰，方便迭代\n\n这些习惯让我的实习从“执行任务”升级为“参与项目推进”。',
            tags: ['实习经验', '能力提升', '产品思维']
        },
        // {
        //     id: 3,
        //     category: 'projects',
        //     question: '哪个项目最能体现你的产品能力？',
        //     answer: '我认为"科技政策平台"项目最能体现我的产品能力：\n\n**产品思维体现**：\n- **用户痛点识别**：发现企业和研究机构在政策理解上的困难\n- **解决方案设计**：通过AI技术提供智能政策分析服务\n- **价值创造**：帮助用户快速理解政策内容，提升决策效率\n\n**技术理解能力**：\n- 深入理解AI技术在产品中的应用\n- 能够与技术团队讨论技术实现的可行性\n- 平衡技术复杂度和用户体验\n\n**商业思维**：\n- 设计了清晰的商业模式\n- 考虑了目标用户群体和付费意愿\n- 制定了产品发展策略\n\n**项目管理**：\n- 协调多个技术栈的开发工作\n- 管理项目进度和里程碑\n- 处理技术难点和风险\n\n这个项目完美结合了我的技术背景、产品思维和商业理解。',
        //     tags: ['项目经验', '产品能力', '技术理解']
        // },
        // {
        //     id: 4,
        //     category: 'skills',
        //     question: '你认为产品经理最重要的技能是什么？',
        //     answer: '我认为产品经理最重要的技能是**用户洞察力**，但需要配合其他核心技能：\n\n**1. 用户洞察力（最重要）**\n- 能够深入理解用户需求和痛点\n- 具备同理心，站在用户角度思考问题\n- 通过用户研究验证产品假设\n\n**2. 数据分析能力**\n- 能够通过数据发现产品问题和机会\n- 建立数据驱动的决策机制\n- 设计有效的A/B测试\n\n**3. 沟通协调能力**\n- 与不同部门高效协作\n- 清晰表达产品需求和目标\n- 处理冲突和推动决策\n\n**4. 商业思维**\n- 理解商业模式和盈利逻辑\n- 平衡用户价值和商业价值\n- 制定产品战略和规划\n\n**5. 技术理解**\n- 理解技术实现的可行性和成本\n- 与技术团队高效沟通\n- 评估技术方案的影响\n\n这些技能相互配合，形成了完整的产品经理能力体系。',
        //     tags: ['核心技能', '用户洞察', '产品思维']
        // },
        {
            id: 5,
            category: 'future',
            question: '你对未来产品经理职业发展有什么规划？',
            answer: `
我希望长期在 AI 产品方向深耕。AI 是未来的通用技术平台（General Purpose Tech），它并不是一个功能或一类产品，而是会不断重塑我们获取知识、完成任务、与系统交互的方式。

当下的 AI 正在经历三个明显转折点：

**1. 从能力突破 → 场景落地**

大模型能力在持续演进，但真正的难点已经转向：如何把 AI 嵌入具体业务，让它成为“可用、有复用价值的系统能力”，而不是一段 Demo 或一款短期工具。

**2. 从工具形态 → 智能体交互**

当前产品形态仍以工具和助手为主，但我更关注的是任务执行、意图理解、策略规划层面的智能。Agent、Workflow、Memory这些方向正在定义下一代人机交互范式。

**3. 从“技术展示” → “价值创造”**

大量 AI 产品停留在“模型包装 + 应用壳子”阶段，真正难的是：

- 找到持续使用场景

- 建立反馈闭环与自学习机制

- 用 AI 重构体验、流程和效率，而非给旧流程贴 AI 标签

我希望成为 懂用户、懂场景、懂技术约束的 AI 产品人，不仅能跟技术团队深度合作，更能判断AI 在哪里真正能带来价值、如何把技术转化为能力与体验。

**✨ 我想做的不是“给产品加 AI”，而是“用 AI 重新定义产品”**

未来几年，我希望探索的方向包括：

- 多轮任务完成型 AI（Agent Systems）

- 行业垂直智能体（Vertical AI）：教育、知识管理、生产力工具、信息服务

- AI 体验设计与行为反馈机制

AI产品不是一个岗位，而是一场时代变革，我想在其中构建真正能改变用户工作与生活方式的东西。
            `,
            tags: ['职业规划', '发展目标', '学习计划']
        }
    ];

    const categories = [
        { id: 'all', name: '全部', count: qaData.length },
        { id: 'education', name: '教育背景', count: qaData.filter(q => q.category === 'education').length },
        { id: 'experience', name: '实习经验', count: qaData.filter(q => q.category === 'experience').length },
        { id: 'projects', name: '项目经验', count: qaData.filter(q => q.category === 'projects').length },
        { id: 'skills', name: '技能能力', count: qaData.filter(q => q.category === 'skills').length },
        { id: 'future', name: '职业规划', count: qaData.filter(q => q.category === 'future').length }
    ];

    const filteredQA = activeCategory === 'all'
        ? qaData
        : qaData.filter(q => q.category === activeCategory);

    return (
        <div className="qa-page">
            <div className="container">
                <div className="page-header">
                    <h1>答疑专区</h1>
                    <p>在这里回答一些关于我的教育背景、实习经历、项目经验和职业规划的问题</p>
                </div>

                <div className="qa-content">
                    <div className="category-sidebar">
                        <h3>问题分类</h3>
                        <ul className="category-list">
                            {categories.map((category) => (
                                <li key={category.id}>
                                    <button
                                        className={`category-btn ${activeCategory === category.id ? 'active' : ''}`}
                                        onClick={() => setActiveCategory(category.id)}
                                    >
                                        {category.name}
                                        <span className="count">({category.count})</span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="qa-list">
                        {filteredQA.map((qa) => (
                            <div key={qa.id} className="qa-item">
                                <div className="question">
                                    <h3>{qa.question}</h3>
                                    <div className="tags">
                                        {qa.tags.map((tag, index) => (
                                            <span key={index} className="tag">{tag}</span>
                                        ))}
                                    </div>
                                </div>
                                <div className="answer">
                                    <ReactMarkdown>{qa.answer}</ReactMarkdown>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                <div className="contact-section">
                    <h2>还有其他问题？</h2>
                    <p>如果您还有其他问题，欢迎通过以下方式联系我：</p>
                    <div className="contact-methods">
                        <a href={`mailto:${config.footer.contact.email}`} className="contact-method">
                            <span className="icon">📧</span>
                            <span>发送邮件</span>
                        </a>
                        {config.footer.contact.linkedin && (
                            <a href={config.footer.contact.linkedin} target="_blank" rel="noopener noreferrer" className="contact-method">
                                <span className="icon">💼</span>
                                <span>LinkedIn</span>
                            </a>
                        )}
                        {config.footer.contact.github && (
                            <a href={config.footer.contact.github} target="_blank" rel="noopener noreferrer" className="contact-method">
                                <span className="icon">💻</span>
                                <span>GitHub</span>
                            </a>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QA;







